import { RowOptionsGetter } from 'CsvImportsModule/types';
import { MEMBER_ACCESS_LEVELS } from 'CsvImportsModule/constants';

export const accessLevelOptionsGetter: RowOptionsGetter = () => {
  return MEMBER_ACCESS_LEVELS;
};
